import apiClient from "../core/HttpClient";
import { TermsAndConditions } from "../models";

export default class TermsAndConditionsService {
  url = "/TermsAndConditions";

  async getTermsAndConditions(): Promise<TermsAndConditions | null> {
    return apiClient.get(this.url).then((response) => response.data);
  }

  async saveTermsAndConditions(data: TermsAndConditions) {
    return apiClient.put(this.url, data);
  }
}
